import { useState } from 'react';

const useFocus = () => {
    let timeout = null;
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
        if (timeout) {
            clearTimeout(timeout);
        }
    };

    const handleBlur = () => {
        timeout = setTimeout(() => {
            setIsFocused(false);
            timeout = null;
        });
    };

    return {
        isFocused,
        onFocus: handleFocus,
        onBlur: handleBlur
    };
};

export default useFocus;